import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { Col, Row } from 'elements'
import { formSubmit } from 'utils/form'
import { createReader, listAllSites } from 'redux/modules/model/site'
import { listAllAgents } from 'redux/modules/model/agent';
import { listClients } from 'redux/modules/model/client'
import { clientsSelector, allSitesInfoSelector, agentsSelector } from 'redux/selectors'
import { ReaderForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'
import reader from '..'

const COMPONENT_CSS_CLASSNAME = 'operator-invite'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class ReaderAdd extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    createReader: PropTypes.func.isRequired,
    listClients: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { clientId, listClients, listAllSites, listAllAgents } = this.props
    listClients({ clientId })
    listAllSites({ clientId })
    listAllAgents({ clientId })
  }

  handleSubmit = (values) => {
    console.log("🚀 ~ file: index.js ~ line 40 ~ ReaderAdd ~ values", values)
    values.readers.forEach(reader => {
      reader.clientId = values.clientId
    })
    console.log("🚀 ~ file: index.js ~ line 45 ~ ReaderAdd ~ values", values)
    // const { history, createReader } = this.props
    // values.readers.map(value => formSubmit(createReader, { ...value }))
    // history.push(ROUTES.READER)
    //test this
  };

  render() {
    const { clientList, sites, agents } = this.props
    return (
      <Row>
        <p className={bemE('back')}><Link to={ROUTES.READER}>&laquo; Back</Link></p>
        <PageContentTitle>Add new readers</PageContentTitle>
        <ReaderForm onSubmit={this.handleSubmit} clients={clientList} sites={sites} agents={agents} />
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  clientList: clientsSelector,
  sites: allSitesInfoSelector,
  agents: agentsSelector
})

export const actions = {
  createReader,
  listClients,
  listAllSites,
  listAllAgents
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(ReaderAdd)



// WEBPACK FOOTER //
// ./src/pages/reader/reader-add/index.js